import { useFocusInvalidField } from "@shared/hooks/useFocusInvalidField";
import { FormElementAttributes } from "@types";
import classNames from "classnames";
import { Field } from "formik";
import { useFormContext } from "./form-context";

interface Props extends FormElementAttributes {
  hasError?: boolean;
}

const TelInput: React.FC<Props> = (props) => {
  const { commonAttrs, hasError, classes } = props;
  const { name, id, placeholder } = commonAttrs;
  const { validate } = useFormContext();
  const { fieldRef } = useFocusInvalidField(name, true);
  return (
    <Field
      type={"tel"}
      name={name}
      validate={(v: any) => validate(name, v)}
      className={classNames(
        classes.join(" "),
        "form-control",
        hasError ? "form-error-validation" : ""
      )}
      id={id}
      placeholder={placeholder}
      innerRef={(el: HTMLElement) => {
        fieldRef.current = el;
      }}
    />
  );
};

export default TelInput;
